<template>
  <div class="container-fluid top-info ps-0" v-if="logged">
    <div class="row">
      <div class="col">
        <button :class="'hamburger hamburger--squeeze mr-3 hide-desktop ' + stateClass" type="button" @click="toggleMenu">
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>
        </button>
        <img src="@/assets/torre-logo.png" class="img-responsive logo">
      </div>
      <div class="col text-right p-1">
        <store-select v-if="isAdmin"/>
        <img :src="avatarUrl" class="avatar-small hide-mobile-sm"/>
        <span class="hide-mobile-sm">{{ loggedUser }}</span>
        <router-link class="btn-sm mr-4 logout-link" :to="{ name: 'logout' }" title="Wyloguj">
          <i class="material-icons center-icon" >
          power_settings_new
          </i>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import userService from '@/service/userService'
import storeSelect from "@/components/utils/StoreSelect";

export default {
  name: "TopBar",
  components: {
    'store-select': storeSelect
  },
  data: () => ({
    loggedUser: "",
    menuOpened: false,
  }),
  created() {
    const user = userService.getCurrentUser();
    this.loggedUser = user.userInfo.userName + " " + user.userInfo.userSurname;
    this.$eventHub.$on('menuClosed', this.onMenuClosed);
  },
  beforeDestroy() {
    this.$eventHub.$off('menuClosed');
  },
  computed: {
    isAdmin() {
      return userService.isAdmin();
    },
    stateClass() {
      return this.menuOpened ? "is-active" : "";
    },
    logged () {
      return userService.isLogged()
    },
    avatarUrl: function() {
      return userService.getAvatarUrl()
    }
  },
  methods: {
    onMenuClosed() {
      this.menuOpened = false;
    },
    toggleMenu() {
      this.menuOpened = !this.menuOpened;
      this.$eventHub.$emit("hamburgerClicked", {
        menuOpened: this.menuOpened
      });
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/place/TopBar.vue